import _getters_list from './_getters/list.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    getters:{
        list: _getters_list,
    },
}